import axios from "axios";
import axiosInstance from "../utilities/axiosSetup";

// Existing API functions below

// Existing authentication functions
export const initiate_login = async (email, password) => {
  const FORM_DATA = new FormData();
  FORM_DATA.append("email", email);
  FORM_DATA.append("password", password);
  let response = await axios.post(
    import.meta.env.VITE_API_URL + "/customer-initiate-login",
    FORM_DATA
  );
  return response.data;
};

export const auth_agent = async () => {
  let response = await axios.get(import.meta.env.VITE_API_URL + "/auth-agent", {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("authToken"),
    },
    withCredentials: true,
  });
  return response.data;
};

export const refresh_token = async () => {
  try {
    // No need to send refresh token in the request body as it's in the HTTP-only cookie
    const response = await axios.post(
      import.meta.env.VITE_API_URL + "/refresh-token",
      {
        refresh_token: localStorage.getItem("refresh_token"),
      }, // Empty body since the refresh token is in the cookie
      {
        withCredentials: true,
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      } // Important to include cookies
    );
    return response.data;
  } catch (error) {
    console.error("Error refreshing token:", error);
    throw error;
  }
};

export const logout = async () => {
  try {
    // No need to send refresh token in the request body as it's in the HTTP-only cookie
    const response = await axiosInstance.post(
      import.meta.env.VITE_API_URL + "/customer-logout",
      {}, // Empty body since the refresh token is in the cookie
      {
        withCredentials: true,
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      } // Important to include cookies
    );
    // Clear access token from sessionStorage
    sessionStorage.removeItem("authToken");
    return response.data;
  } catch (error) {
    console.error("Error during logout:", error);
    // Even if server-side logout fails, clear access token
    sessionStorage.removeItem("authToken");
    return { success: true };
  }
};
